module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("I")]), _vm._v("owe a big thank you to so many people who helped me to get this book written. Too many to personally thank all of them, but there are a few to whom I am particularly grateful to:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First of all, my parents who made it all possible. Secondly, but crucially, my dear friends, Dr Alex Service, Kirsty Hartsiotis, and Michael Gaunt, who helped me stay sane when I was working on my DPhil thesis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to thank all the people who helped with their suggestions and encouragement. To name but a few: my supervisor Prof Mark Ormrod, who sadly is not here anymore to see the book published, Dr Katherine Lewis, Bille Zipperer, Dr Joanna Laynesmith, and all my sisters, in particular my sister Sabine who read through most of the manuscript. A special thank you to Kirsty Hartsiotis (again) for her great help in sourcing the images, and thank you to Sally Baldham for the image of the tomb of John Lovell IX.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another big thank you to Orderic Vitalis, the countless medieval scribes of administrative records, to the editors of all those fantastic documents, and to the librarians and archivists in England and Germany with a special thanks to the staff of the Bavarian State Library.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Last but not least, I want to thank everyone at Pen and Sword Books who offered me the chance to write about the Lovells, and in particular Danna Messer for her encouragement and support.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0a33c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0